import React, {ReactElement} from 'react';
import DownArrow from '@assets/images/medops/down_arrow.svg';
import {useTranslation} from 'react-i18next';

const DownArrowIcon = (props: any): ReactElement => {
  const {t} = useTranslation();
  return (
    <img
      src={DownArrow}
      height={15}
      width={15}
      {...props}
      alt={t('DUE_INVOICES.DOWN_ARROW')}
    />
  );
};
export default DownArrowIcon;
